export { InfoFaq } from './InfoFaq';
